// Shared RUL constants used across RUL chart, detail, breakdown, and scatter components.

export const ALL_Y_FILTERS = [
  { key: "months", label: "Months & Years" },
  { key: "cycles", label: "Cycles"         },
  { key: "km",     label: "km"             },
];

export const Y_KEY = { months: "rulMonths", cycles: "rulCycles", km: "rulKm" };

export const RUL_BUCKET_KEYS = {
  months: "RULMonthsBucket",
  cycles: "RULCyclesBucket",
  km:     "RULKmBucket",
};

export const RUL_UNIT_METRIC = {
  months: "RULCalendarAgeDaysPredicted",
  cycles: "RULCyclesPredicted",
  km:     "RULKmPredicted",
};
